import {
    getQueryParamFromUrl,
    accessCodeInUrl,
    setAccessCodeInSession,
    authenticateAccessCode,
} from 'hooks/live-airmeet/useAccessCodeUserToken';
import React, { useMemo } from 'react';
import { Route } from 'react-router-dom';
import useRouteBase from './common';
import history from '../../history';

const PublicRoute = ({ component: Component, ...rest }) => {
    useRouteBase({ ...rest });
    const isEventRoute = rest.exact && '/e/:id' === rest.path;

    useMemo(() => {
        if (!isEventRoute) {
            return false;
        }
        let queryName = getQueryParamFromUrl(history);
        if (queryName) {
            setAccessCodeInSession({
                queryParam: queryName,
                tokenVal: accessCodeInUrl(queryName, history),
                airmeetId: rest.computedMatch.params?.id,
                replaceUrl: rest.location.pathname,
            });
        } else {
            authenticateAccessCode(rest.computedMatch.params?.id);
        }
    }, [isEventRoute, rest.computedMatch.params.id, rest.location.pathname]);

    return (
        <Route
            {...rest}
            render={(props) => {
                return <Component {...props} />;
            }}
        />
    );
};

export default PublicRoute;
